import React from 'react';
import { ModalComponent } from 'components/modal/modalComponent';
import './ReminderModal.scss';

export const ReminderModal = ({ isOpen, onConfirm, title, bodyText, cancelText, onCancel, confirmText }) => (
    <ModalComponent
        isOpen={isOpen}
        confirmText={confirmText}
        cancelText={cancelText}
        onCancel={onCancel}
        onConfirm={onConfirm}
        title={title}
        className="reminder-modal"
    >
        <div>{bodyText}</div>
    </ModalComponent>
);
